import request from '@/utils/request';

export default {
    // 添加企业信息
    async getAncient (params) {
        const res = await request.get('/ancient/' + params.path, { params })
        return res.data
    }
};
